<template>
  <div class="projects-media-create">
    <v-overlay :value="!hasLoaded">
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>

    <div
      v-if="hasLoaded"
      class="icon__container"
      @click="$router.go(-1)"
    >
      <v-icon color="#880e4f">
        mdi-arrow-left
      </v-icon>
    </div>

    <app-drawing-zone
      v-if="hasLoaded"
      :drawing.sync="drawing"
      :background-layer="backgroundLayer"
      @click-camera="$router.push({ name: 'app-camera-tool' })"
      @delete-background="deleteBackground"
      @save="save"
    />
  </div>
</template>

<script>
import { AppDrawingZone } from "../../shared/components";
import ErrorHandlingMixin from "@/mixins/ErrorHandlingMixin.vue";
const uuid = require("uuid/v4");

export default {
  name: "AppProjectsMediaCreate",
  components: {
    AppDrawingZone
  },
  mixins: [ErrorHandlingMixin],

  data() {
    return {
      hasLoaded: true
    };
  },

  computed: {
    // Background layer for then canvas (usually an image)
    backgroundLayer: {
      get() {
        return this.$store.state.medias.backgroundLayer;
      },

      set(value) {
        this.$store.commit("medias/SET_BACKGROUND_LAYER", value);
      }
    },

    // The drawing (aka draw, aka painting, aka paint)
    drawing: {
      get() {
        return this.$store.state.medias.drawing;
      },

      set(value) {
        this.$store.commit("medias/SET_DRAWING", value);
      }
    },

    // Final image (drawing + background layer)
    // Better to work and keep aspect ratio right 'cause its just an image
    finalImage: {
      get() {
        return this.$store.state.medias.finalImage;
      },

      set(value) {
        this.$store.commit("medias/SET_FINAL_IMAGE", value);
      }
    }
  },

  // Reset Vuex values
  beforeDestroy() {
    this.drawing = null;
    this.backgroundLayer = null;
    this.finalImage = null;
  },

  methods: {
    deleteBackground() {
      this.backgroundLayer = null;
    },

    // Update drawing in Vuex
    updateDrawing(drawing) {
      this.drawing = drawing;
    },

    // Update final image in Vuex
    updateFinalImage(final_image) {
      this.finalImage = final_image;
    },

    // Create a new media
    async save(data_uri) {
      try {
        // Start loading process
        this.hasLoaded = false;

        // Get date and hour
        const now = new Date();
        const date =
          now.toISOString().split("T")[0] +
          " " +
          now.toTimeString().split(" ")[0];

        // Prepare object to be saved
        const media = {
          uuid: uuid(),
          project_uuid: this.$route.params.uuid,
          croquis: this.drawing,
          image: this.backgroundLayer,
          final_image: data_uri,
          created_at: date
        };

        // Save to indexedDB
        await this.$db.medias.add(media);

        this.$notify({
          group: "main",
          type: "success",
          title: "Succès",
          text: "Media enregistré",
          duration: 5000
        });

        // Go back
        this.$router.go(-1);
      } catch (e) {
        const errorMsg =
          "Le média n'a pas pu être enregistré. Réessayer ultérieurement";
        this.handleError(e, errorMsg); // TODO: Send error to server
        console.error(e);
      } finally {
        // Finally stop loading proces
        this.hasLoaded = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.projects-media-create {
  height: 100%;
  display: flex;
  justify-content: center;

  .icon__container {
    position: absolute;
    cursor: pointer;
    top: 24px;
    left: 24px;
    width: 32px;
    height: 32px;
  }
}
</style>
